export default {
  BORDER_COLOR: '#e8e7eb',
  BLACK: '#151035',
  GREY: '#F0F2F5',
  PRIMARY: '#42D483',
  SECONDARY: '#312675',
  ALERT: '#FF3B30;',
};
